import React from "react";
import MainLayout from "../layouts/MainLayout";
import HeroSection from "../components/HeroSection";
import useApplyAction from "../hooks/useApplyAction";

function Home() {
  const handleApplyClick = useApplyAction();

  return (
    <MainLayout onApplyClick={handleApplyClick}>
      <HeroSection onApplyClick={handleApplyClick} />
    </MainLayout>
  );
}

export default Home;
